import categories from '@/store/categories';
import { fi } from 'vuetify/locale';

export default {
  welcome: 'Tervetuloa takaisin',
  accounts: 'Tilisi',
  account: 'Tili',
  dashboard: "Ohjauspaneeli",
  loading: 'Ladataan...',
  products: "Tuotteet",
  suppliers: "Toimittajat",
  customers: "Asiakkaat",
  users: "Käyttäjät",
  product: "Tuote",
  productStatus: "Tuotteen tila",
  newProduct: "Uusi tuote",
  errorCreateProduct: "Virhe tuotteen luomisessa, tarkista kaikki kentät uudelleen.",
  errorUpdateProduct: "Virhe tuotteen päivittämisessä, tarkista kaikki kentät uudelleen.",
  errorDeleteProduct: "Virhe poistamista tuotteen.",
  regulationsSuccess: "Sädettäminen onnistui",
  regulationsError: "Sädettäminen epäonnistui, tarkista kaikki kentät uudelleen.",
  restock: "Täydennä varasto",
  editProduct: "Muokkaa tuotetta",
  deleteProduct: "Poista tuote",
  productCreated: "Tuote luotu",
  productUpdated: "Tuote päivitetty",
  productDeleted: "Tuote poistettu",
  regulationQuantity: "Säädä määrä",
  addSubtract: "Lisää / Vähennä",
  newLocation: "Uusi sijainti",
  movementFrom: "Siirto kohteesta",
  cancel: "Peruuta",
  move: "Siirrä",  
  currentStock: "Nykyinen varasto",
  stockRegulations: "Varaston säädöt",
  quantityToMove: "Siirrettävä määrä",
  editLocation: "Muokkaa sijaintia",
  deleteLocation: "Poista sijainti",
  locationCreated: "Sijainti luotu",
  locationUpdated: "Sijainti päivitetty",
  locationDeleted: "Sijainti poistettu",
  missingLocation: "Puuttuva sijainti",
  newSupplier: "Uusi toimittaja",
  editSupplier: "Muokkaa toimittajaa",
  deleteSupplier: "Poista toimittaja",
  supplierCreated: "Toimittaja luotu",
  supplierUpdated: "Toimittaja päivitetty",
  supplierDeleted: "Toimittaja poistettu",
  newCustomer: "Uusi asiakas",
  editCustomer: "Muokkaa asiakasta",
  deleteCustomer: "Poista asiakas",
  customerCreated: "Asiakas luotu",
  customerUpdated: "Asiakas päivitetty",
  customerDeleted: "Asiakas poistettu",
  companyNumber: "Yrityksenumero",
  companyName: "Yritys",
  address1: "Osoite 1",
  address2: "Osoite 2",
  city: "Kaupunki",
  zipCode: "Postinumero",
  country: "Maa",
  contactPhone: "Yhteysnumero",
  contactEmail: "Sähköposti",
  contactPerson: "Yhteyshenkilö",
  supplier: "Toimittaja",
  customer: "Asiakas",
  purchases: "Ostot",
  purchase: "Osto",
  sales: "Myynti",
  sale: "Myynti",
  user: "Käyttäjä",
  about: "Tietoja Capture IT",
  orders: "Tilaukset",
  inventory: "Tilastot",
  reports: "Raportit",
  priceValue: "Varaston arvo",
  stockValue: "Varaston arvo",
  regulations: "Varaston säädöt",
  stockMovements: "Varaston siirrot",
  checkingDrafts: "Laskelmien tarkistus",
  locations: "Sijainnit",
  locationNumber: 'Sijainnin numero',
  defaultLocation: 'Oletussijainti',
  supplier: 'Toimittaja',
  number: 'Numero',
  name: 'Nimi',
  locationName: 'Sijainnin nimi',
  mandatoryDefaultLocation: '*Oletussijainti',
  location: 'Sijainti',
  selectRemoveAll: 'Valitse / Poista kaikki',
  accountNumber: 'Tilinumero',
  fullname: 'Koko nimi',
  email: 'Sähköposti',
  role: 'Rooli',
  actions: 'Toiminnot',
  general: 'Yleinen',
  other: 'Muu',
  update: 'Päivitä',
  image: 'Kuva',
  productImage: 'Tuotekuva',
  barcode: 'Viivakoodi',
  quantity: 'Määrä',
  labelQuantity: 'Etiketin määrä',
  price: 'Hinta',
  pricePerUnit: 'Hinta per yksikkö',
  salesPrice: 'Myyntihinta',
  purchasePrice: 'Ostohinta',
  total: 'Yhteensä',
  productName: 'Tuotenimi',
  mandatoryProductName: '*Tuotenimi',
  productNumber: 'Tuotenumero',
  mandatoryProductNumber: '*Tuotenumero',
  productGroup: 'Tuoteryhmä',
  stock: 'Tilastot',
  minStock: 'Minimi varasto',
  status: 'Tilaus',
  published: 'Julkaistu',
  scheduled: 'Aikataulutettu',
  inactive: 'Poistettu',
  date: 'Päivämäärä',
  description: 'Kuvaus',
  height: 'Pituus',
  width: 'Leveys',
  depth: 'Leveys',
  weight: 'Paino',
  quantity: 'Määrä',
  usersPerPageText: 'Käyttäjiä sivulla:',
  productsPerPageText: 'Tuotteita sivulla:',
  locationsPerPageText: 'Sijaintoja sivulla:',
  suppliersPerPageText: 'Toimittajia sivulla:',
  customersPerPageText: 'Asiakkaita sivulla:',
  purchasesPerPageText: 'Ostoja sivulla:',
  salesPerPageText: 'Myyntejä sivulla:',
  ordersPerPageText: 'Tilauksia sivulla:',
  itemsPerPageText: 'Rivejä sivulla:',
  of: ' /',
  to: ' -',
  on: 'on',
  quantity: 'Määrä',
  one: 'yksi',
  note: 'Huomautus',
  pageText: '{0}-{1} / {2}',
  fullnameMandatory: 'Koko nimi on pakollinen',
  emailInvalid: 'Virheellinen sähköposti',
  userMandatory: 'Käyttäjätunnus ja salasana ovat pakollisia',
  emailMandatory: 'Sähköposti on pakollinen',
  userCreated: 'Käyttäjä luotu!',
  errorCreateUser: 'Virhe luomista käyttäjää, tarkista kaikki kentät uudelleen.',
  userdeleted: 'Käyttäjä on poistettu',
  errorDeleteUser: 'Virhe poistamista käyttäjää',
  appname: 'PicklyWMS',
  login: 'Kirjaudu sisään',
  settings: 'Asetukset',
  importExport: 'Impordi / Expordi',
  import: 'Impordi',
  export: 'Expordi',
  importProducts: 'Impordi tuotteita',
  exportProducts: 'Expordi tuotteita',
  uploadFile: 'Lähetä tiedosto',
  uploadFileText: 'Lähetä Excel tai CSV tiedosto tähän.',
  uploadSucceded: 'Lähetys onnistui',
  uploadFailed: 'Lähetys epäonnistui',
  language: 'Kieli',
  darkMode: 'Tumma moda',
  showProducts: 'Näytä inaktiiviset tuotteet',
  showLocations: 'Näytä inaktiiviset sijainnit',
  other: 'Muu',
  selectLanguage: 'Valitse kieli',
  english: 'Englanti',
  danish: 'Tanska',
  swedish: 'Ruotsi',
  norwegian: 'Ruotsi',
  finnish: 'Suomi',
  enabled: 'Ota käyttöön',
  disabled: 'Poista käytöstä',
  required: 'Pakollinen',
  optional: 'Valinnainen',
  username: 'Käyttäjänimi',
  password: 'Salasana',
  print: 'Tulosta',
  printSelected: 'Tulosta valitut',
  close: 'Sulje',
  save: 'Tallenna',
  cancel: 'Peruuta',
  reset: 'Nollaa',
  clear: 'Tyhjennä',
  create: 'Luo',
  edit: 'Muokkaa',
  delete: 'Poista',
  confirmDelete: 'Vahvista poisto',
  deleteWarningUser: 'Haluatko varmasti poistaa tämän käyttäjän?',
  deleteWarningProduct: 'Haluatko varmasti poistaa tämän tuotteen?',
  error: 'Virhe',
  success: 'Onnistui',
  info: 'Info',
  warning: 'Varoitus',
  submit: 'Lähetä',
  search: 'Haku',
  newUser: 'Uusi käyttäjä',
  editUser: 'Muokkaa käyttäjää',
  deleteUser: 'Poista käyttäjä',
  userCreated: 'Käyttäjä luotu!',
  userDeleted: 'Käyttäjä poistettu!',
  userEdited: 'Käyttäjä muokattu!',
  oneRegistered: 'On yksi rekisteröity',
  thereAreXRegistered: 'On rekisteröity',
  weHaveOneRegistered: 'Meillä on yksi rekisteröity',
  weHaveXRegistered: 'Meillä on rekisteröity',
  warehouseManagement: 'Varastonhallinta',
  trade: 'Trade',
  notYetImplemented: 'Ei vielä toteutettu',
  notYetImplementedText: 'Tämä ominaisuus ei ole vielä toteutettu. Palaa myöhemmin tarkistamaan päivitykset.',
  goBack: 'Palaa takaisin',
  categories: 'Kategoriat',
  category: 'Kategoria',
  newCategory: 'Uusi kategoria',
  editCategory: 'Muokkaa kategoriaa',
  deleteCategory: 'Poista kategoria',
  categoryCreated: 'Kategoria luotu',
  categoryUpdated: 'Kategoria päivitetty',
  categoryDeleted: 'Kategoria poistettu',
  errorCreateCategory: 'Virhe luotaessa kategoriaa, tarkista kaikki kentät uudelleen.', 
  errorUpdateCategory: 'Virhe päivittäessä kategoriaa, tarkista kaikki kentät uudelleen.',
  errorDeleteCategory: 'Virhe poistettaessa kategoriaa.',
  mandatoryCategoryName: '*Kategorian nimi',
  categoryName: 'Kategorian nimi',
  categoryDescription: 'Kategorian kuvaus',
  categoriesPerPageText: 'Kategorioita sivulla:',
  usePrintServer: "Käytä Print Serveriä (Silent Printing)",
  printJobSent: "Tulostustyö lähetetty palvelimelle.",
  printJobsSent: "Kaikki tulostustyöt lähetetty palvelimelle.",
  printJobFailed: "Tulostustyö epäonnistui",
  printServerConnectionError: "Yhteyttä print serveriin ei voitu muodostaa. Onko se käynnissä?",
  printBatchFailed: "Tulostuserä epäonnistui. Vähintään yhtä työtä ei voitu lähettää.",
  noLabelSelectedError: "Ei valittua etikettimallia.",
  onlyInStock: "Vain varastossa olevat tuotteet",
  valueFromCostPrice: "Arvo perustuu kustannushintaan"
};
